import { Loading } from 'helpers/enums';

import type { CredentialsState } from './types';

export const credentialsInitialState: CredentialsState = {
  loading: Loading.IDLE,
};
